import { createTheme } from "@mui/material/styles"
import { defaultTheme } from "components/Theme/Style"

const themeNewsletter = createTheme(defaultTheme, {
  palette: {
    mode: 'light',
    primary: { main: '#003247', dark: '#00496b' },
    secondary: { main: '#ff4d4d' },
    neutral: { main: '#5c6ac4' },
    error: { main: '#8b0000' }
  },
  typography: {
    body2: {
      fontSize: '0.75rem',
      fontWeight: 400
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
          padding: '0 !important',
          borderRadius: 0
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[8],
          borderRadius: theme.shape.borderRadius
        })
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[8],
          borderRadius: theme.shape.borderRadius
        })
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          minHeight: 36
        },
        input: {
          padding: '7px 14px'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          height: 'auto',
          minHeight: 'unset',
          paddingTop: 7,
          paddingBottom: 7,
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          height: 'auto'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 36
        }
      }
    },
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          minHeight: 36
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: '#8b0000'
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&:not(.MuiInputLabel-root)': {
            fontSize: '12px',
            fontWeight: 400
          }
        }
      }
    }
  }
})

export default themeNewsletter